import { render, staticRenderFns } from "./AddressSuggestionModal.vue?vue&type=template&id=4ed954aa&scoped=true"
import script from "./AddressSuggestionModal.vue?vue&type=script&lang=js"
export * from "./AddressSuggestionModal.vue?vue&type=script&lang=js"
import style0 from "./AddressSuggestionModal.vue?vue&type=style&index=0&id=4ed954aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed954aa",
  null
  
)

export default component.exports